if (!customElements.get("input-phone")) {
  function getBrowserLocales(options = {}) {
    const defaultOptions = {
      languageCodeOnly: false,
    };

    const opt = {
      ...defaultOptions,
      ...options,
    };

    const browserLocales =
      navigator.languages === undefined
        ? [navigator.language]
        : navigator.languages;

    if (!browserLocales) {
      return undefined;
    }

    return browserLocales.map((locale) => {
      const trimmedLocale = locale.trim();

      return opt.languageCodeOnly
        ? trimmedLocale.split(/-|_/)[0]
        : trimmedLocale;
    });
  }
  class InputPhone extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector("input");
      this.hiddenInput = this.querySelector('input[type="hidden"]');
      this.userPrefLocales = getBrowserLocales();
    }
    connectedCallback() {
      let currentLocale = 'auto';
      if (this.userPrefLocales && this.userPrefLocales.length > 0) {
        const localeParts = this.userPrefLocales[0].split("-");
        currentLocale = localeParts.length > 1 && localeParts[1] ? localeParts[1] : (localeParts[0] || 'auto');
      }

      this.iti = window.intlTelInput(this.input, {
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.5.0/build/js/utils.js",
        autoPlaceholder: "off",
        initialCountry: currentLocale ? currentLocale : "auto"
      });
      this.input.addEventListener("change", () => this.setHiddenInputValue());
      this.input.addEventListener("keyup", () => this.setHiddenInputValue());
    }
    setHiddenInputValue() {
      if (this.iti.isValidNumber()) {
        this.hiddenInput.value = this.iti.getNumber();
      } else {
        this.hiddenInput.value = "";
      }
    }
  }
  customElements.define("input-phone", InputPhone);
}
